import { API_BASE_URL } from '../config/api'
import { getAuthHeaders } from '../utils/authUtils'
import { firebaseAuthService } from '../services/firebaseAuthService'

// Request email verification using Firebase's native API
export async function requestEmailVerification(): Promise<void> {
  const result = await firebaseAuthService.sendEmailVerification()
  if (!result.success) {
    throw new Error(result.error || 'Failed to send verification email')
  }
}

// Sync Firebase email verification status to backend
export async function syncEmailVerificationStatus(): Promise<void> {
  await firebaseAuthService.syncEmailVerificationStatus()
}

// Legacy endpoint for token-based confirmation (kept for backward compatibility)
// Firebase handles email confirmation automatically, but we sync the status
export async function confirmEmailVerification(_token?: string): Promise<void> {
  // Token parameter kept for backward compatibility but not used
  // Firebase handles the verification automatically, we just need to sync
  await firebaseAuthService.syncEmailVerificationStatus()
}

export async function requestPhoneOtp(options?: {
  phone?: string
  testOnly?: boolean
}): Promise<{ devCode?: string; testOnly?: boolean; phoneVerified?: boolean }> {
  const response = await fetch(`${API_BASE_URL}/api/auth/verification/phone/request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify({
      ...(options?.phone ? { phone: options.phone } : {}),
      ...(options?.testOnly ? { testOnly: true } : {})
    })
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Failed to send verification code')
  return data.data || {}
}

export async function confirmPhoneOtp(code: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/api/auth/verification/phone/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify({ code })
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Failed to verify phone')
}


